import React from 'react';
import { useError } from '../contexts/ErrorContext';

const ErrorNotification = () => {
    const { error, setError } = useError();

    if (!error) return null;

    return (
        <div className="fixed top-0 left-0 w-full bg-white p-8 z-20">
            <div className="border border-4 border-red-500 rounded-lg p-8 md:w-4/5 md:mx-auto">
                <p>{error.message}</p>
                <button onClick={() => setError('')} className="mt-8 border border-black px-6 py-1.5">
                    Close
                </button>
            </div>
        </div>
    );
};

export default ErrorNotification;
